module.exports = __webpack_public_path__ + "static/mfs-869bc42a2399de2d2431c67e925892fa.png";